module.exports = {
        srcSet: __webpack_public_path__ + "static/media/letter-500.de6cec8f.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/letter-500.de6cec8f.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/letter-500.de6cec8f.webp",
        toString: function(){return __webpack_public_path__ + "static/media/letter-500.de6cec8f.webp"},
        
        width: 500,
        height: 500
      }